import { Badge } from "@/components/ui/badge";

const MAP = {
  UNASSIGNED: "bg-gray-100 text-gray-700 border-gray-200",
  RESERVED: "bg-amber-100 text-amber-800 border-amber-200",
  ACTIVE: "bg-green-100 text-green-800 border-green-200",
  SUSPENDED: "bg-orange-100 text-orange-800 border-orange-200",
  RETIRED: "bg-red-100 text-red-800 border-red-200",
  INACTIVE: "bg-gray-100 text-gray-700 border-gray-200",
};

export function StatusBadge({ status }) {
  return (
    <Badge
      variant="outline"
      className={`font-medium ${MAP[status] || "bg-gray-100 text-gray-700"}`}
      data-testid={`status-badge-${status}`}
    >
      {status}
    </Badge>
  );
}
